import {AppointmentsListContainer} from './styles';
import {Button} from '@mui/material';
import {ContentState} from 'presentation/components';
import React from 'react';
import {AppointmentsHistoryEmptyStateProps} from './types';
import {translations} from 'presentation/translations-new';

const {newAppointment, emptyAppointment} = translations['pt-br'].privateFlow.myAppointments;

export function AppointmentsHistoryEmptyState({
	description,
	hideButton,
	handleNewAppointment,
}: AppointmentsHistoryEmptyStateProps) {
	return (
		<AppointmentsListContainer>
			<ContentState
				description={description}
				title={emptyAppointment.titleHistory}
				customIconName="history-clock"
				footer={
					hideButton ? null : (
						<Button onClick={handleNewAppointment} variant="contained" size="large">
							{newAppointment}
						</Button>
					)
				}
			/>
		</AppointmentsListContainer>
	);
}
